import React, { useEffect, useState } from 'react';
import { Row, Col, message } from 'antd';
import DndListCard from 'Molecules/DndListCard';
import HeadingChip from 'Molecules/HeadingChip';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getDiscountList } from '../ducks/actions'
import { removeDiscount, bulkRemoveDiscounts, updateDiscountsOrder } from '../ducks/services'
import ActionButton from 'Molecules/ActionButton';
import Search from './components/Search';
import AllRoles from '../../../../routing/config/AllRoles';
import { allowed } from '../../../../routing/config/utils';
import { getListQueryItems } from 'Modules/Application/ducks/actions';
import { useTranslate } from 'Translate';

export default (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const discounts = useSelector((state) => state.pos.discounts);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchVal, setSearchVal] = useState(null);
  const [hasDirty, setHasDirty] = useState(false);
  const [data, setData] = useState([]);
  const allowedEdit = allowed([AllRoles.POS.DISCOUNT], 'write');
  const allowedDelete = allowed([AllRoles.POS.DISCOUNT], 'delete');
  const globalListQuery = useSelector((state) => state.global.listQueryItems);
  const i18n = useTranslate();
  const { t } = i18n;

  const colName = [
    {
      title: t("General.code"),
      dataIndex: 'code',
      key: 'code',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("General.desc"),
      dataIndex: 'desc',
      key: 'desc',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Pos.discount_rate"),
      dataIndex: 'discount_amount',
      key: 'discount_amount',
      className: 'enable-click',
      align: 'right',
      sorter: true
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      align: 'center',
      render: (text, record) =>
        <ActionButton
          title="discount"
          btnAction1={() => navigate(`/pos/discount/${record.id}`)}
          recordId={record.id}
          onRemove={allowedDelete && onRemove}
          setLoading={props.setLoading}
          loading={props.loading}
        />
    }
  ];

  const addNew = () => navigate('/pos/discount/add');

  const btnList = [
    {
      title: t("Product.confirm_reorder_list"),
      text: t("General.update_listing"),
      classes: 'b-success attendance-success',
      btnHidden: !hasDirty,
      action: () => onUpdateList()
    },
    {
      title: t("Confirm.remove_select_discounts"),
      text: t("General.bulk_remove"),
      classes: 'red-btn text-white attendance-success',
      permit: true,
      action: () => onBulkRemove(),
    },
    {
      text: `+ ${t("New.discount")}`,
      classes: 'attendance-success',
      action: () => addNew(),
    },
  ];

  useEffect(() => {
    if(!globalListQuery.discountListQuery) {
      dispatch(getDiscountList(1, limit, '', '', null, props.setLoading));
      dispatch(getListQueryItems('discountListQuery', 1, limit, '', '', null, props.setLoading));
    } else {
      const {page, limit, sortOrder, sortColKey, searchValue} = globalListQuery.discountListQuery
      dispatch(getDiscountList(page, limit, sortOrder, sortColKey, searchValue, props.setLoading));
      setPage(page);
      setLimit(limit);
      setSearchVal(searchValue);
    }
  }, []);

  useEffect(() => {
    if (discounts) {
      setData(discounts?.list);
    }
  }, [discounts]);


  const onTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if (sorter.order) {
      dispatch(getDiscountList(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading));
      dispatch(getListQueryItems('discountListQuery', pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading))
    } else {
      dispatch(getDiscountList(pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading));
      dispatch(getListQueryItems('discountListQuery', pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading))
    }
  }

  const onSearch = (search) => {
    setPage(1);
    if (search) {
      let searching = {};
      searching = {
        code: search.code // code_cont_or_desc_cont
      };
      setSearchVal(searching);
      dispatch(getDiscountList(1, limit, '', '', searching, props.setLoading));
      dispatch(getListQueryItems('discountListQuery', 1, limit, '', '', searching, props.setLoading))
    } else {
      setSearchVal(null);
      dispatch(getDiscountList(1, limit, '', '', null, props.setLoading));
      dispatch(getListQueryItems('discountListQuery', 1, limit, '', '', null, props.setLoading))
    }
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onRemove = async (id) => {
    props.setLoading(true);

    const payload = {
      discount_id: id,
      status_event: 'remove'
    }

    await removeDiscount(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.remove_discount"));
        setTimeout(() => dispatch(getDiscountList(page, limit, '', '', searchVal, props.setLoading)), 500);
        dispatch(getListQueryItems('discountListQuery', page, limit, '', '', searchVal, props.setLoading))
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onBulkRemove = async () => {
    props.setLoading(true);

    const payload = {
      discounts: JSON.stringify(selectedRowKeys)
    }

    await bulkRemoveDiscounts(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        rowSelection.onChange([]);
        message.success(t("Success.remove_discount"));
        setPage(1);
        setSearchVal(null);
        setTimeout(() => dispatch(getDiscountList(1, limit, '', '', null, props.setLoading)), 500);
        dispatch(getListQueryItems('discountListQuery', 1, limit, '', '', null, props.setLoading))
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onUpdateList = async () => {
    props.setLoading(true);

    const payload = {
      discounts: JSON.stringify(data?.map((d, i) => ({ id: d.id, position: i + 1 })))
    }
    await updateDiscountsOrder(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.order_update_discounts"));
        setHasDirty(false);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  return (
    <Row gutter={[10, 10]}>
      <Col span={24}>
        <HeadingChip title={t("General.discounts")} btnList={allowedEdit ? btnList : null} btnHidden={selectedRowKeys.length <= 0} />
      </Col>
      <Col span={24} className="">
        <DndListCard
          setHasDirty={setHasDirty}
          setDataList={setData}
          list={data}
          ListData={data?.map((x, ind) => ({ ...x, key: x.id, index: ind + 1 }))}
          ListCol={colName}
          Search={Search}
          onSearch={onSearch}
          searchVal={globalListQuery.discountListQuery?.searchValue}
          onChange={onTableChange}
          rowSelection={allowedEdit && rowSelection}
          pagination={{
            total: data?.total_count,
            current: page,
            pageSize: limit
          }}
        />
      </Col>
    </Row>
  )
}